import { Drilldown } from '@data/components/report/ReportFilterBar/ReportFilterBar';
import { useReportOutletContext } from '@data/pages/ReportLayout/ReportLayout';
import { resolveMetrics, type MetricRule } from '@data/utils/resolve-metrics';
import { ReportHighlights } from '@data/components/report/ReportHighlights/ReportHighlights';
import { SkillClassTable } from '@data/components/report/SkillClassTable/SkillClassTable';
import { SkillPerformanceTable } from '@data/components/report/SkillPerformanceTable/SkillPerformanceTable';

// ── Skill Performance Primary Metrics ──────────────────────────────────────────

const PRIMARY_METRICS: MetricRule[] = [
  { metric: 'TEXTS_COMPLETED' },
  { metric: 'SHORT_READ_CARDS_COMPLETED' },
  { metric: 'READ_AND_RECORD_ACCURACY' },
];

// ── Component ──────────────────────────────────────────────────────────────────

export function SkillPage() {
  const { drilldown, productId: edApp } = useReportOutletContext();

  const primaryMetricTypes = resolveMetrics(PRIMARY_METRICS, edApp, drilldown);

  return (
    <div className="flex w-full min-w-0 max-w-full flex-col gap-6">
      <ReportHighlights primaryMetricTypes={primaryMetricTypes} />
      <SkillPerformanceTable />
      {drilldown !== Drilldown.Student && <SkillClassTable />}
    </div>
  );
}
